__turbopack_context__.v({
  "arrow": "JournalFeatured-module-scss-module__BprqiG__arrow",
  "blink": "JournalFeatured-module-scss-module__BprqiG__blink",
  "categories": "JournalFeatured-module-scss-module__BprqiG__categories",
  "category": "JournalFeatured-module-scss-module__BprqiG__category",
  "content": "JournalFeatured-module-scss-module__BprqiG__content",
  "hasImage": "JournalFeatured-module-scss-module__BprqiG__hasImage",
  "image": "JournalFeatured-module-scss-module__BprqiG__image",
  "imageFull": "JournalFeatured-module-scss-module__BprqiG__imageFull",
  "imageHover": "JournalFeatured-module-scss-module__BprqiG__imageHover",
  "journalFeatured": "JournalFeatured-module-scss-module__BprqiG__journalFeatured",
});
